import type { CssConstants } from "~/styles/exports/constants"
import values from "~/styles/tokens/breakpoints.json"

export const breakpoints: CssConstants = {
  values,
  toCss: () =>
    [
      "$breakpoints: (",
      ...Object.entries(values).map(([k, v]) => `  "${k}": ${v},`),
      ");",
    ].join("\n"),
}
